!function(){var n={};webpackJsonp([6],{27:function(e,i,o){"use strict";n[27]=e.exports}},[27]),window.define("./js/home/index.js",[],function(){return n[27]})}();


// WEBPACK FOOTER //
// home.js